import React from 'react';



export interface IUseDialogControl {
  isOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

export interface IUseDialogControlArgs {
  openOnId?: string;

  onClose?: () => void;
}

export function useDialogControl(args: IUseDialogControlArgs): IUseDialogControl {
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    setIsOpen(open => {
      if (!open && args.openOnId) {
        return true;
      }

      return open;
    });
  }, [args.openOnId, setIsOpen]);

  return {
    isOpen,
    openDialog: () => {
      setIsOpen(true);
    },
    closeDialog: () => {
      if (args.onClose) {
        args.onClose();
      }
      setIsOpen(false);
    }
  };
}
